import {basicUpgradeTotal, type BasicUpgrades} from './basicUpgrades.js';

/** Owner-confirmed Basic selling price, October 23, 2026. White finish and
 * standard installation are part of the base; delivery and tax are separate. */
export const BASIC_BED_PRICE = 6995;
export const BASIC_CUSTOM_COLOR_PRICE = 500;

export function basicBedSubtotal(upgrades: BasicUpgrades = {}, finish?: string) {
  return BASIC_BED_PRICE + (finish === 'custom_color' ? BASIC_CUSTOM_COLOR_PRICE : 0) + basicUpgradeTotal(upgrades);
}
